





























































import { Vue, Component, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import SelectTree from "@/components/selectTree.vue"
import manageService from "@/services/manage.service"
import { FormModel } from "ant-design-vue"
import { ScheduleNoticeList } from "./constant"
import { mapGetters } from "vuex"
@Component({
    components: {
        PageHeader,
        SelectTree
    },
    computed: {
        ...mapGetters("common", ["version_type"])
    }
})
export default class IterationList extends Vue {
    readonly version_type: any
    product_version_id: number = null
    detailInfo: any = {}
    scheduleDetail: any = {}

    form: any = {
        cc_uids: [],
        end_date: "",
        product_version_id: "",
        reason: ""
    }

    labelCol = { span: 4 }
    wrapperCol = { span: 12 }

    get productName() {
        const { full_name } = this.detailInfo
        return `${full_name || "-"}`
    }

    get rules() {
        return {
            end_date: [{ required: true, message: "请选择", trigger: "blur" }],
            reason: [{ required: true, message: "请输入调整原因", trigger: "blur" }]
        }
    }

    get scheduleNoticeList() {
        return ScheduleNoticeList
    }

    get originSchedule() {
        return this.scheduleDetail?.version_schedule
    }

    get versionStr() {
        return (
            this.version_type.find((item: any) => item.value === this.detailInfo.version_type)
                ?.label || "-"
        )
    }

    @Ref("ruleForm")
    refFrom: FormModel

    created() {
        this.product_version_id = Number(this.$route.query.id)
        this.getDetail()
        this.adjustScheduleDetail()
    }

    goBack() {
        this.$router.go(-1)
    }

    async getDetail() {
        try {
            const res: any = await manageService.getVersionDetail({
                product_version_id: this.product_version_id
            })
            this.detailInfo = res || {}
        } catch (error) {
            this.$message.error(`${error},获取详情失败！`)
        }
    }
    async adjustScheduleDetail() {
        try {
            const res: any = await manageService.adjustScheduleDetail({
                product_version_id: this.product_version_id
            })
            this.scheduleDetail = res || {}
        } catch (error) {
            this.$message.error(`${error},获取详情失败！`)
        }
    }
    btnLoading = false
    async submit() {
        try {
            await this.refFrom.validate()
            this.$confirm({
                title: "请确认是否进行排期调整？",
                onOk: () => {
                    this.adjustSchedule()
                }
            })
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
    async adjustSchedule() {
        try {
            this.btnLoading = true
            await manageService.adjustSchedule({
                ...this.form,
                product_version_id: this.product_version_id
            })
            this.$message.success(`项目排期调整成功！`)
            this.$router.push({
                path: "/manage/version-detail",
                query: {
                    id: String(this.product_version_id),
                    activeTab: "schedule"
                }
            })
        } catch (error) {
            this.$message.error(`${error}，提交失败！`)
        } finally {
            this.btnLoading = false
        }
    }
}
